/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const ModTags: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M3.293 4.70724C2.902 4.31624 2.902 3.68424 3.293 3.29324C3.684 2.90224 4.316 2.90224 4.707 3.29324C5.098 3.68424 5.098 4.31624 4.707 4.70724C4.316 5.09824 3.684 5.09824 3.293 4.70724ZM6.33 0.000244141H1.616C0.724 0.000244141 0 0.724244 0 1.61624V6.33024C0 6.75924 0.17 7.17024 0.474 7.47424L7.857 14.8572C8.488 15.4882 9.512 15.4882 10.143 14.8572L14.857 10.1432C15.488 9.51224 15.488 8.48824 14.857 7.85724L7.474 0.474244C7.17 0.170244 6.759 0.000244141 6.33 0.000244141Z'
			/>
		</Svg>
	);
};

export { ModTags };
